// flexinet-users-api, per stage. The app owns this table; @flexinet/users-components
// takes the endpoint and region through UsersApiProvider (FNP-2016).
import {stage} from './stage.ts';

const usersApi = {
    prod: {
        endpoint: 'https://f42lx6qgonahbclkzlqekvm4le.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    test: {
        endpoint: 'https://2m6swoqvfberhbziynzu7zc4qu.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    dev: {
        endpoint: 'https://ynqjnxb7nja5bgwn7gsxvsiukq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    ide: {
        endpoint: 'https://ynqjnxb7nja5bgwn7gsxvsiukq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
};

export const usersApiConfig = usersApi[stage];
